export default function getURIFileType(uri) {
  const url = new URL(uri)
  const pathname = url.pathname
  const extension = pathname.split('.').pop()
  return extension.includes('/') ? '' : extension
}
